import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import Anchor from "../elements/Anchor";
import "../../styles/components/slices/services-boxes.scss";

const ServicesBoxes = ({ slice }) => {
  if (!slice) return null;

  return (
    <Container className="section services-boxes max-container">
      <Row className="justify-content-between mb-3 mb-md-5">
        {slice.primary.title.text !== null && (
          <Col md={8}>
            <h2 className="title-65">{slice.primary.title.text}</h2>
          </Col>
        )}
        {slice.primary.image.gatsbyImageData !== null && (
          <Col sm={12} md={2} className="align-self-end d-none d-md-block">
            <GatsbyImage
              image={slice.primary.image.gatsbyImageData}
              alt={slice.primary.image.alt || "ims logo"}
              className="mb-2"
            />
          </Col>
        )}
      </Row>
      <Row>
        {slice.items.map((box, index) => (
          <Col md={6} xl={3} key={index} className="mb-2 mb-md-4">
            <div className="box">
              <Anchor
                href={box.link.url}
                className="text-decoration-none h-100"
                target={box.link.target}
              >
                <div className="d-flex flex-md-column justify-content-md-between h-100 align-items-center align-items-md-start">
                  <div className="content-border">
                    {box.box_icon.gatsbyImageData !== null && (
                      <GatsbyImage
                        image={box.box_icon.gatsbyImageData}
                        alt={box.box_icon.alt || "box images"}
                        className="box-icons"
                      />
                    )}
                  </div>
                  <p className="text-white mb-0 mt-md-4 ms-4 ms-md-0 me-3 me-md-0 description">
                    {box.box_title}
                  </p>
                </div>
              </Anchor>
            </div>
          </Col>
        ))}
      </Row>
      {slice.primary.button_label && slice.primary.button_link.url ? (
        <div className="book-now-dark mx-auto mt-5 d-none d-lg-block mona">
          <Anchor
            href={slice.primary.button_link.url}
            className="book-now-btn text-center"
            target={slice.primary.button_link.target}
          >
            {slice.primary.button_label}
          </Anchor>
        </div>
      ) : null}
    </Container>
  );
};

export default ServicesBoxes;
